import React from 'react';
import { motion } from 'framer-motion';
import { Footprints, Dumbbell, Activity, Repeat } from 'lucide-react';

const OUTCOMES = [
  { icon: Footprints, label: 'Run or train without pain' },
  { icon: Dumbbell, label: 'Lift with confidence' },
  { icon: Activity, label: 'Move better every day' },
  { icon: Repeat, label: 'Stay consistent long-term' },
];

export default function OutcomesSection() {
  return (
    <section className="py-16 px-6 bg-[#0B0B0B] text-white" data-testid="outcomes-section">
      <div className="container mx-auto max-w-5xl">
        <div className="text-center text-xs uppercase tracking-widest text-[#C6A97C] font-semibold mb-10">
          What you'll be able to do again
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 sm:gap-6">
          {OUTCOMES.map((o, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className="flex flex-col items-center text-center gap-3"
              data-testid={`outcome-${i}`}
            >
              <o.icon className="w-9 h-9 text-[#C6A97C]" strokeWidth={1.5} />
              <span className="text-sm sm:text-base text-gray-300">{o.label}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
